const prefix = 'learn.dropbox.com/user';

export const LOADING_USER_PROFILE = `${prefix}/LOADING_USER_PROFILE`;
export const LOADED_USER_PROFILE = `${prefix}/LOADED_USER_PROFILE`;
export const NOT_LOGGED_IN = `${prefix}/NOT_LOGGED_IN`;
